import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import "../../css/Slider.css";

const Slider = () => {
  const slides = useRef([]);
  const dots = useRef([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoPlayDuration = 5000; // 4 seconds
  const [isPlaying, setIsPlaying] = useState(true);
  let autoPlayInterval = useRef(null);

  // تعریف آرایه‌ای از اسلایدها
  const slideData = [
    {
      title: "مشاوره مسیر",
      subtitle: "با آرامش و وضوح",
      description:
        "اگر نمی‌دانی قدم بعدی چیست، این فرم برای همین طراحی شده. \
نه فروش، نه فشار؛ فقط شفاف‌سازی مسیر متناسب با شرایط واقعی تو.",
      button1: "📝 شروع مشاوره",
      button2: "📞 گفت‌وگوی مستقیم",
      button1Link: "/consultation",
      button2Link: "/contact",
      imageIcon: "💬",
      imageText: "CONSULT",
      additionalText: "FREE",
      label: "مشاوره تخصصی",
      labelShort: "CONSULT",
      themeClass: "consult-theme",
    },
    {
      title: "تبدیل به",
      subtitle: "متخصص وردپرس",
      description:
        "صفر تا صد راه‌اندازی وردپرس روی لوکال هاست و هاست واقعی + کار عملی با تم‌ها، پلاگین‌ها و بک‌آپ",
      button1: "🔧 شروع کنید",
      button2: "🌐 مشاهده دوره وردپرس",
      button1Link: "/courses/2",
      button2Link: "/courses/2",
      imageIcon: "🖥️",
      imageText: "WP",
      additionalText: "MASTER",
      label: "دوره Master Plus وردپرس",
      labelShort: "WP",
    },
    {
      title: "شروع کنید از",
      subtitle: "الفبای کدنویسی",
      description:
        "از الگوریتم و فلوچارت تا ساختارهای برنامه‌نویسی و کدنویسی عملی با پایتون — مناسب برای مبتدیان کامل",
      button1: "🧩 یاد بگیرید",
      button2: "🐍 دوره برنامه‌نویسی",
      button1Link: "/courses",
      button2Link: "/courses",
      imageIcon: "🔤",
      imageText: "CODE",
      additionalText: "BEGINNER",
      label: "آموزش جامع الفبای برنامه‌نویسی",
      labelShort: "CODE",
    },
    {
      title: "آینده با",
      subtitle: "هوش مصنوعی",
      description: "از صفر تا حرفه‌ای با هوش جدید",
      button1: "🚀 شروع یادگیری",
      button2: "📚 مشاهده دوره‌ها",
      button1Link: "/courses",
      button2Link: "/courses",
      imageIcon: "🤖",
      imageText: "AI",
      additionalText: "HYBRID",
      label: "هوش مصنوعی",
      labelShort: "AI",
    },
    {
      title: "قدرت",
      subtitle: "Node.js و Express",
      description: "توسعه بک‌اند مقیاس‌پذیر و کارآمد",
      button1: "🚀 شروع کنید",
      button2: "📦 دوره‌های بک‌اند",
      button1Link: "/courses",
      button2Link: "/courses",
      imageIcon: "🟢",
      imageText: "Node",
      additionalText: "EXPRESS",
      label: "توسعه بک‌اند حرفه‌ای",
      labelShort: "BE",
    },
    {
      title: "دنیای",
      subtitle: "جاوااسکریپت و ری‌اکت",
      description: "توسعه اپلیکیشن‌های مدرن و پویا",
      button1: "🚀 شروع کنید",
      button2: "⚛️ دوره‌های ری‌اکت",
      button1Link: "/courses",
      button2Link: "/courses",
      imageIcon: "⚛️",
      imageText: "JS",
      additionalText: "REACT",
      label: "توسعه فرانت‌اند حرفه‌ای",
      labelShort: "FE",
    },
  ];

  useEffect(() => {
    bindEvents();
    startAutoPlay();
    return () => {
      pauseAutoPlay();
    };
  }, []);

  useEffect(() => {
    updateSlider();
  }, [currentSlide]);

  const bindEvents = () => {
    document.getElementById("prevBtn").addEventListener("click", prevSlide);
    document.getElementById("nextBtn").addEventListener("click", nextSlide);

    dots.current.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    document
      .querySelector(".slider-container")
      .addEventListener("mouseenter", pauseAutoPlay);
    document
      .querySelector(".slider-container")
      .addEventListener("mouseleave", startAutoPlay);
  };

  const updateSlider = () => {
    slides.current.forEach((slide, index) => {
      slide.classList.remove("active", "prev", "next");

      if (index === currentSlide) {
        slide.classList.add("active");
      } else if (
        index ===
        (currentSlide - 1 + slideData.length) % slideData.length
      ) {
        slide.classList.add("prev");
      } else {
        slide.classList.add("next");
      }
    });

    dots.current.forEach((dot, index) => {
      dot.classList.toggle("active", index === currentSlide);
    });
  };

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slideData.length); // به اسلاید بعدی بروید
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prevSlide) => (prevSlide - 1 + slideData.length) % slideData.length
    ); // به اسلاید قبلی بروید
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const startAutoPlay = () => {
    if (isPlaying) {
      autoPlayInterval.current = setInterval(() => {
        nextSlide(); // به اسلاید بعدی بروید
      }, autoPlayDuration);
    }
  };

  const pauseAutoPlay = () => {
    clearInterval(autoPlayInterval.current);
  };

  return (
    <section className="hero-bg py-3 md:py-5">
      <div className="container mx-auto px-4">
        <div className="slider-container">
          <div className="slider-wrapper" id="sliderWrapper">
            {slideData.map((slide, index) => (
              <div
                className={`slide ${index === currentSlide ? "active" : ""}`}
                data-slide={index}
                ref={(el) => (slides.current[index] = el)}
                key={index}
              >
                <div className="slide-content">
                  <div className="content-text">
                    <h2 className="text-4xl md:text-6xl font-bold mb-6 text-white leading-tight">
                      {slide.title}{" "}
                      <span className="block text-light">{slide.subtitle}</span>
                    </h2>
                    <p className="text-xl md:text-2xl mb-8 text-white opacity-95 leading-relaxed">
                      {slide.description}
                    </p>
                    <div className="btn-group flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                      <Link
                        to={slide.button1Link}
                        className="btn-primary px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg"
                      >
                        {slide.button1}
                      </Link>
                      <Link
                        to={slide.button2Link}
                        className="btn-secondary px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg hidden sm:block"
                      >
                        {slide.button2}
                      </Link>
                    </div>
                  </div>
                  <div className="content-image">
                    <div
                      className={`image-container image-container-${
                        index + 1
                      } ${slide.themeClass || ""}`}
                    >
                      <div className="text-8xl mb-4">{slide.imageIcon}</div>
                      <div className="text-dark font-bold text-2xl opacity-90">
                        {slide.imageText}
                      </div>
                      <div className="text-dark font-bold text-xl opacity-90 hidden sm:block">
                        {slide.additionalText}
                      </div>
                      <div
                        className={`absolute bottom-4 text-dark text-sm opacity-70 hidden sm:block`}
                      >
                        {slide.label}
                      </div>
                      <div
                        className={`absolute top-4 right-4 ${
                          slide.themeClass === "bf-theme"
                            ? "bf-theme-badge"
                            : index === 0
                            ? "bg-primary"
                            : "bg-dark"
                        } px-3 py-1 text-white rounded-full text-xs font-bold`}
                      >
                        {slide.labelShort}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          <div className="slider-arrows arrow-left">
            <button className="arrow-btn" id="prevBtn">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>
          </div>
          <div className="slider-arrows arrow-right">
            <button className="arrow-btn" id="nextBtn">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Slider Dots */}
          <div className="slider-dots" id="sliderDots">
            {slideData.map((_, index) => (
              <div
                className={`dot ${index === currentSlide ? "active" : ""}`}
                data-slide={index}
                ref={(el) => (dots.current[index] = el)}
                key={index}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider;
